import { METHODS, num, fmtFull } from "../lib/format";

const Row = ({ l, r, bold }) => (
  <div className={`flex justify-between gap-2 ${bold ? "font-bold text-[13px]" : ""}`}>
    <span>{l}</span>
    <span className="text-right whitespace-nowrap">{r}</span>
  </div>
);

const Sep = () => <div className="border-t border-dashed border-black/60 my-1.5" />;

export const Receipt = ({ tx, store, width = "58mm", print = false }) => {
  const w = print ? (width === "80mm" ? "72mm" : "48mm") : width === "80mm" ? "300px" : "220px";
  return (
    <div className="receipt-paper text-[11px] leading-snug" style={{ width: w, padding: print ? "2mm" : "14px 12px" }} data-testid="receipt-preview">
      <div className="text-center">
        {store.logo && store.print_logo && <img src={store.logo} alt="" className="mx-auto mb-1 max-h-14 object-contain grayscale" />}
        <div className="font-bold text-sm uppercase">{store.store_name}</div>
        {store.tagline && <div className="italic">{store.tagline}</div>}
        {store.address && <div>{store.address}</div>}
        {store.phone && <div>Telp: {store.phone}</div>}
      </div>
      <Sep />
      <div>No&nbsp;&nbsp;&nbsp;: {tx.invoice}</div>
      <div>Tgl&nbsp;&nbsp;: {fmtFull(tx.created_at)}</div>
      <div>Kasir: {tx.cashier_name}</div>
      {tx.customer_name && <div>Plgn&nbsp;: {tx.customer_name}</div>}
      <Sep />
      {tx.items.map((it, i) => (
        <div key={i} className="mb-1">
          <div>{it.name}</div>
          <Row l={`  ${it.qty} x ${num(it.price)}`} r={num(it.price * it.qty)} />
          {it.discount > 0 && <Row l={`  ${it.promo_name || "Diskon"}`} r={"-" + num(it.discount)} />}
        </div>
      ))}
      <Sep />
      <Row l="Subtotal" r={num(tx.subtotal)} />
      {tx.discount > 0 && <Row l="Diskon" r={"-" + num(tx.discount)} />}
      {tx.points_discount > 0 && <Row l={`Tukar ${tx.points_redeemed} poin`} r={"-" + num(tx.points_discount)} />}
      {tx.tax > 0 && <Row l={`Pajak (${tx.tax_percent}%)`} r={num(tx.tax)} />}
      <Row l="TOTAL" r={"Rp " + num(tx.total)} bold />
      <Row l={`Bayar (${METHODS[tx.payment_method] || tx.payment_method})`} r={num(tx.paid)} />
      {tx.payment_method === "tunai" && <Row l="Kembali" r={num(tx.change)} />}
      {tx.customer_id && (<><Sep /><Row l="Member" r={tx.customer_name} />{tx.points_earned > 0 && <Row l="Poin didapat" r={"+" + tx.points_earned} />}{tx.customer_points != null && <Row l="Total poin" r={num(tx.customer_points)} />}</>)}
      {tx.status === "batal" && <div className="text-center font-bold mt-1">*** DIBATALKAN ***</div>}
      <Sep />
      {store.footer && <div className="text-center">{store.footer}</div>}
    </div>
  );
};

export const ReceiptPaper = (props) => (
  <div className="mx-auto w-fit drop-shadow-xl">
    <div className="receipt-edge top" />
    <Receipt {...props} />
    <div className="receipt-edge" />
  </div>
);
